export default __webpack_public_path__ + "static/practice-areas-header-a39e1def0ff3b777f0e6a9fc97952ffb.jpg";